import { Fragment, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import { Button } from 'components/molecules/orders/List/styled';
import { ReactComponent as DeleteIcon } from 'assets/images/delete.svg';
import routeCodes from 'common/constants/route-codes';
import { Wrapper, Row, RowItem, Delete } from './styled';
import { Divider } from 'components/atoms/styleds';
import Modal from './modal';

const getDuration = (duration) => {
  const [time = '', text = ''] = duration?.split('_');
  return `${time} ${text}`;
};

const ServicesList = ({
  list = [],
  inProcess,
  onDelete,
  onEdit,
  isSuperAdmin,
  currentRestaurant,
  showDivider = true,
  showTitle = true,
  showDetails = true,
}) => {
  const [serviceToDelete, setServiceToDelete] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const createRoute = isSuperAdmin
    ? routeCodes.superAdmin.settingsConfigsServicesView.replace(
        ':restaurantId',
        currentRestaurant?.id,
      )
    : routeCodes.settingsConfigsServicesView;

  const handleDeleteClick = (service) => {
    setServiceToDelete(service);
    setIsModalOpen(true);
  };

  const handleConfirmDelete = async () => {
    if (serviceToDelete) {
      setServiceToDelete(null);
      setIsModalOpen(false);
      await onDelete(serviceToDelete);
    }
  };

  const handleCancelDelete = () => {
    setServiceToDelete(null);
    setIsModalOpen(false);
  };

  return (
    <Wrapper>
      {showTitle && (
        <>
          <Row isTitle={true}>
            <RowItem title='true'>Nome servizio</RowItem>
            <RowItem hiddenMobile={true} title='true'>
              Totale coperti
            </RowItem>
            <RowItem hiddenMobile={true} title='true'>
              Durata media del servizio
            </RowItem>
          </Row>
        </>
      )}
      {showDivider && <Divider />}
      {list?.map((i, index) => (
        <Fragment key={i.id}>
          <Row>
            <RowItem>{i.title}</RowItem>
            {showDetails && (
              <>
                <RowItem hiddenMobile={true}>
                  <span style={{ paddingLeft: 30 }}>{i.total_seats}</span>
                </RowItem>
              </>
            )}

            <RowItem>
              {showDetails && (
                <RowItem
                  hiddenMobile={true}
                  style={{ display: 'block', textAlign: 'center' }}
                >
                  {getDuration(i.service_duration)}
                </RowItem>
              )}

              <RowItem justify='flex-end'>
                {onEdit ? (
                  <Button
                    mt={0}
                    mr={20}
                    bgColor='#FF7828'
                    style={{ textDecoration: 'none' }}
                    onClick={() => onEdit(i.id)}
                    disabled={inProcess}
                  >
                    Modifica
                  </Button>
                ) : (
                  <Button
                    as={Link}
                    to={createRoute.replace(':id', i.id)}
                    mt={0}
                    mr={20}
                    bgColor='#FF7828'
                    style={{ textDecoration: 'none' }}
                  >
                    Modifica
                  </Button>
                )}
                <Delete
                  as={DeleteIcon}
                  disabled={inProcess}
                  role='presentation'
                  onClick={() => handleDeleteClick(i)}
                />
              </RowItem>
            </RowItem>
          </Row>
          <Divider style={{ opacity: 0.3 }} />
        </Fragment>
      ))}

      {isModalOpen && (
        <Modal
          title='Conferma eliminazione'
          onClose={handleCancelDelete}
          footer={
            <>
              <Button onClick={handleCancelDelete}>Annulla</Button>
              <Button onClick={handleConfirmDelete} disabled={inProcess}>
                Elimina
              </Button>
            </>
          }
        >
          Sei sicuro di voler eliminare il servizio "{serviceToDelete?.title}"?
        </Modal>
      )}
    </Wrapper>
  );
};

export default ServicesList;
